import * as React from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import { AutocompleteField }  from "~common/components/fields/autocomplete-field-fc";
import {Grid} from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    QuestionField: {
      width: "100%",
    },
    questionLabel: {
      fontSize: ".85rem",
      width: "70%",
      margin: "5px",
      alignItems: "baseline",
      paddingRight: 3
    },
    questionFlexbox: {
      display: "flex",
      width: "100%",
      alignItems: "baseline",
      flexGrow: 1,
    },
    titleQuestionContainer: {
      width: "100%"
    }
  })
);

interface QuestionProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
  error?: any;
}


export const QuestionField: React.FC<QuestionProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setFieldVal will pass the value up to the parent component that houses the context.

  const [fieldVal, setFieldVal] = useContext(ValueContext);;


  let titleQuestion = (
    <div dangerouslySetInnerHTML={{__html: fieldDefinition.title}}>
      
    </div>
  );

  if (fieldDefinition.mode == "Required") {
    titleQuestion = (
        <div dangerouslySetInnerHTML={{__html: fieldDefinition.title + '<span style="color: red">&nbsp;*</span>'}}></div>
    );
  } else if (fieldDefinition.mode == "Key Field") {
    titleQuestion = (
      <div dangerouslySetInnerHTML={{__html: fieldDefinition.title + '<i style="color: red; margin-left: 5px" class="fa fa-key"></i>'}}></div>
    );
  }


  return (

    <div className={classes.questionFlexbox} >
      <span className={classes.questionLabel}>
          {titleQuestion}
      </span>
      {/* Field */}
      <div className={classes.questionFlexbox}>
        <ValueContext.Provider value={[fieldVal, setFieldVal]}>
          <AutocompleteField
            fieldDefinition={fieldDefinition}
            policyMessages={policyMessages}
            readOnlyOverride={readOnlyOverride}
          />
        </ValueContext.Provider>
      </div>
    </div>
  )
};

export default QuestionField;
